import i18next from 'i18next';

/** Registers English strings for program UI. */
export default function initI18n(): void {
  i18next.addResourceBundle('en', 'program-ui', {
    programsTitle: 'Programs',
    addProgram: 'Add program',
    addProgramTitle: 'Add a program',
    newFolder: 'New folder',
    newFolderCreated: 'Folder created',
    close: 'Close',
    overviewTitle: 'Overview',
    overviewMeta_one: '{{count}} current program',
    overviewMeta_other: '{{count}} current programs',
    overviewBackToOverview: 'Back to overview',
    programDetailAbout: 'About this program',
    programListItemStatus: '{{status}} · {{percent}}%',
    status_current: 'Current',
    status_paused: 'Paused',
    status_completed: 'Completed',
    status_abandoned: 'Abandoned',
    libraryDaysLabel: 'days',
    libraryDays_one: '{{count}} day',
    libraryDays_other: '{{count}} days',
    libraryTimeRange: '{{min}}–{{max}} min/week',
    draftChip: 'Draft',
    continueButton: 'Continue',
    tryButton: 'Try',
    startButton: 'Start',
    skipButton: 'Skip',
    resumeButton: 'Resume',
    restoreProgram: 'Restore',
    archiveProgram: 'Archive',
    unarchiveProgram: 'Unarchive',
    programArchivedSuccess: 'Program archived',
    programUnarchivedSuccess: 'Program unarchived',
    signalLearning: 'Learning',
    signalPractice: 'Practice',
    signalResults: 'Results',
    overallProgress: 'Overall progress',
    openPostMortem: 'Open post-mortem',
    effortTrivial: 'Trivial',
    effortEasy: 'Easy',
    effortMedium: 'Medium',
    effortHard: 'Hard',
    pauseProgram: 'Pause program',
    abandonProgram: 'Abandon program',
    programPageMenu: 'Program actions',
    pauseProgramConfirmTitle: 'Pause this program?',
    pauseProgramConfirmDescription:
      'Your habits will stay in place, but calendar events during the pause are cleared until you resume.',
    abandonProgramConfirmTitle: 'Abandon this program?',
    abandonProgramConfirmDescription:
      'Empty habits may be removed. Habits with completed work are kept.',
    startProgramDialogTitle: 'Start {{name}}',
    startProgramStartDate: 'Start date',
    runnerNext: 'Next',
    runnerOutlineButton: 'Outline',
    runnerNavIntroduction: 'Introduction',
    runnerNavConclusion: 'Conclusion',
    runnerNavItem: 'Step {{current}} of {{total}}',
    runnerConclusionTitle: 'You reached the end of this preview',
    runnerConclusionTitleEnrolled: 'You reached the end of this program',
    runnerStartPhaseTitle: 'Start {{name}}',
    runnerPhaseStartDate: 'Phase start date',
    runnerPhaseHabits: 'Habits to add',
    runnerPhaseMetrics: 'Metrics to track',
    runnerStartPhaseButton: 'Start phase',
    runnerPhaseDates: '{{start}} – {{end}}',
    runnerLessonDue: 'Due {{date}}',
    lessonQuizReadOnly: 'Start the program to take this quiz.',
    lessonQuizInactiveSlide: 'Continue to this slide to take the lesson quiz.',
    lessonQuizPoolName: '{{lessonName}} pool',
    lessonQuizReadOnlyWithCount:
      'This lesson quiz has {{count}} questions. Start the program to take it.',
    lessonQuizAttemptLabel: 'Attempt {{current}} of {{max}}',
    lessonQuizGradeLabel: 'Grade: {{percent}}% ({{total}}/{{max}})',
    lessonQuizRetake: 'Retake',
    lessonQuizStarting: 'Starting quiz…',
    interviewStepReadOnly: 'Start the program to have this conversation.',
    interviewStepFinish: 'Finish interview',
    interviewStepAnalyzing: 'Analyzing your answers…',
    programLessonQuizIdLabel: 'Question pool',
    programLessonCreatePool: 'Create pool',
    programLessonUploadPoolTitle: 'Upload Quiz Files',
    programLessonUploadPoolInstructions: 'Select JSON quiz files to upload pool questions',
    programLessonUploadPool: 'Upload pool questions',
    programStepBotGroupLabel: 'Bot group',
    programStepBotHandleLabel: 'Program bot',
    programStepPromptIdLabel: 'Interview prompt',
    programStepCreatePrompt: 'Create prompt',
    programStepAnalysisPromptIdLabel: 'Analysis prompt',
    emptyLibrary: 'No programs in the library',
    programPageAuthor: 'Author: {{author}}',
    programPageNotFound: 'Program not found',
    programPageOutlineTitle: 'Outline',
    programPagePhaseLabel: 'Phase {{ord}}: {{name}}',
    programPagePhaseHabits: 'Habits: {{names}}',
    programPagePhaseMetrics: 'Metrics: {{names}}',
    programPageEnrollmentDates: '{{startDate}} – {{endDate}}',
    programPageLessonLabel: 'Lesson {{ord}}: {{name}}',
    programAdminTitle: 'Programs',
    programPhaseAdminTitle: 'Program phases',
    programLessonAdminTitle: 'Program lessons',
    programStepAdminTitle: 'Program steps',
    programHabitAdminTitle: 'Program habits',
    programMetricAdminTitle: 'Program metrics',
    programParameterAdminTitle: 'Program parameters',
    userProgramAdminTitle: 'User programs',
    programGridOpenEditor: 'Open editor',
    programGridOpenPhases: 'Open phases',
    programGridOpenLessons: 'Open lessons',
    programGridOpenSteps: 'Open steps',
    programGridOpenHabits: 'Open habits',
    programGridOpenMetrics: 'Open metrics',
    programGridOpenParameters: 'Open parameters',
    programGridDeleteSelectedTooltip: 'Delete selected programs',
    programGridGroupDeleteSuccess: '{{count}} program(s) deleted',
    programGridGroupDeleteFailed: 'Failed to delete programs',
    programGridUpdateFailed: 'Failed to update program',
    programGridDeleteConfirmTitle: 'Delete program',
    programGridDeleteConfirmDescription: 'Are you sure you want to delete the program "{{name}}"?',
    programGridTrashSuccess: 'Program trashed',
    programGridRestoreFailed: 'Could not restore the program',
    programGridAddRequiresLogin: 'Must be logged in to add a program',
    programGridAddRequiresProgram: 'Open this grid from a program to add rows',
    programMetricGridNoCatalogMetric: 'No catalog metric is available to add a program metric row',
    programLessonGridAddRequiresPhase: 'Add a phase to this program before adding lessons',
    programStepGridAddRequiresLesson: 'Add a lesson to this program before adding steps',
    programChildGridDeleteConfirmTitle: 'Delete row',
    programChildGridDeleteConfirmDescription: 'Delete "{{name}}"?',
    programChildGridDeleteSuccess: 'Row deleted',
    programPhaseGridDeleteConfirmTitle: 'Delete phase',
    programPhaseGridDeleteConfirmDescription: 'Delete phase "{{name}}"?',
    programPhaseGridDeleteSuccess: 'Phase deleted',
    programGridDeleteVerb: 'Delete',
    programGridNounSingular: 'Program',
    programGridNounPlural: 'Programs',
    editorName: 'Name',
    editorHandle: 'Handle',
    editorVersion: 'Version',
    editorTagline: 'Tagline',
    editorEpigraph: 'Epigraph',
    editorDescription: 'Description',
    editorCoverImageId: 'Cover image ID',
    editorDomain: 'Domain',
    editorPracticeId: 'Practice ID',
    editorLevel: 'Level',
    editorDays: 'Days',
    editorTimePerWeekMin: 'Min minutes per week',
    editorTimePerWeekMax: 'Max minutes per week',
    editorOutcomeMetricId: 'Outcome metric ID',
    editorCustomizationNote: 'Customization note',
    editorShowPhaseNumbers: 'Show phase numbers',
    editorShowLessonNumbers: 'Show lesson numbers',
    editorShowStepNumbers: 'Show step numbers',
    editorPublishedAt: 'Published',
    editorArchivedAt: 'Archived',
    editorGroupIdentity: 'Identity',
    editorGroupLibrary: 'Library card',
    editorGroupCoach: 'Coach notes',
    editorGroupDisplay: 'Display',
    editorGroupPublishing: 'Publishing',
    publishedChip: 'Published',
    designProgramButtonTitle: 'Design new program',
    designProgramDialogTitle: 'Design a program',
    designProgramConfirm: 'Design',
    designProgramPracticeLabel: 'Practice',
    designProgramTopicLabel: 'Or topic',
    designProgramTopicHelper:
      'Use a practice from the library or describe a topic in your own words.',
    designProgramLevelLabel: 'Level',
    designProgramLevelIntro: 'Intro',
    designProgramLevelBeginner: 'Beginner',
    designProgramLevelIntermediate: 'Intermediate',
    designProgramLevelAdvanced: 'Advanced',
    designProgramLevelPro: 'Pro',
    designProgramDaysLabel: 'Days',
    designProgramConstraintsLabel: 'Constraints',
    designProgramRequiresLogin: 'Sign in to design a program',
    designProgramPracticeOrTopicRequired: 'Choose a practice or enter a topic',
    designProgramSnack:
      'Designing your program — the draft appears in Programs when the job finishes.',
    designProgramSnackAction: 'Open executions',
    designProgramAdminAction: 'Design a program',
    designProgramAdminActionSecondary:
      'Run the Program Designer bot on a practice or topic (creates a draft program)',
    programGridAssist: 'Assist',
    programAssistTitle: 'Program assist',
    programAssistChatPlaceholder: 'Ask for pages, questions, habits, or metrics',
  });
}
